{
  "error": "Fout",
  "help": "Help",
  "info": "Informatie",
  "success": "Geslaagd",
  "warning": "Waarschuwing"
}
